import { render } from "./Rank.vue?vue&type=template&id=1b1dda88"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__